import { Dispatch } from 'react';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from 'src/common/components/Buttons';
import { DEFAULT_ERROR_STATE, ErrorObject } from '../types';
import { mobileBreakpoint } from '../mobileBreakpoint';

const Wrapper = styled.div`
  padding: 1em 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  button {
    font-size: 12px;
    min-width: 5em;
  }
  .questions__len {
    font: 500 0.875rem/1.0625rem Inter, sans-serif;
    color: #475467;
  }
  @media ${mobileBreakpoint.mobile} {
    background-color: #fff;
    width: 91.5vw;
    padding: 1em;
  }
`;

const formatNumWith2Digits = (num: number) =>
  num.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

type Props = {
  currentQuestion?: number;
  handleChangeStep: (type: 'NEXT' | 'PREV') => void;
  questions: any;
  questionnaireValue: any;
  setQuestionnaireValue: Dispatch<any>;
  selectedQuestionId: string;
  isLoading: boolean;
  error: ErrorObject;
  setError: Dispatch<ErrorObject>;
};

const SAMPLE_TEXT =
  'Dependents are your children or anyone living with you full time other than the two heads of the household. Having more dependents can reduce your ability to take risk.';

function ActionBar({
  currentQuestion = 0,
  handleChangeStep,
  questions,
  questionnaireValue = {},
  setQuestionnaireValue,
  selectedQuestionId,
  isLoading,
  error,
  setError,
}: Props) {
  const handleNext = () => {
    handleChangeStep('NEXT');
  };
  const handleErrorObject = () => {
    setError(DEFAULT_ERROR_STATE);
  };
  return (
    <Wrapper>
      <SecondaryButton
        onClick={() => {
          handleChangeStep('PREV');
          handleErrorObject();
        }}
      >
        Back
      </SecondaryButton>
      <span className="questions__len">{`${formatNumWith2Digits(
        currentQuestion + 1,
      )} / ${formatNumWith2Digits(questions?.length ?? 0)}`}</span>
      <PrimaryButton
        disabled={
          isLoading ||
          !Object.keys(questionnaireValue).includes(selectedQuestionId) ||
          questionnaireValue[selectedQuestionId] === undefined ||
          error.valid
        }
        onClick={handleNext}
      >
        {questions?.length - 1 === currentQuestion ? 'Finish' : 'Next'}
      </PrimaryButton>
    </Wrapper>
  );
}

export default ActionBar;
